<template>
  <div>
    <el-dialog
      title="选择园区列表"
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      append-to-body
      class="dialogClass"
      width="800px"
    >
      <el-form :inline="true">
        <el-form-item label="园区名称" label-width="100">
          <el-input
            v-model="searchForm.name"
            placeholder="园区名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getStoreGoodsList" type="success">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        border
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          align="center"
          fixed="left"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          label="园区id"
          align="center"
          prop="id"
          width="150"
        ></el-table-column>
        <el-table-column
          label="园区名称"
          align="center"
          prop="name"
          width="320"
        ></el-table-column>
        <el-table-column
          prop="icon"
          align="center"
          width="230"
          fixed="right"
          label="操作"
        >
          <template slot-scope="scope">
            <el-button type="primary" plain @click="selStoreGood(scope.row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="current"
        :page-size="size"
        :total="total"
      ></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GetGardenList",
  data() {
    return {
      searchForm: {},
      tableData: [],
      multipleSelection: [],
      total: 0,
      size: 10,
      current: 1,
      dialogTableVisible: false,
    };
  },
  // created() {
  //     this.getStoreGoodsList()
  // },
  methods: {
    resetForm() {
      this.dialogTableVisible = false;
      this.searchForm = {};
      this.tableData = [];
      this.multipleSelection = [];
      this.total = 0;
      this.size = 10;
      this.current = 1;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSizeChange(val) {
      this.size = val;
      this.getStoreGoodsList();
    },
    handleCurrentChange(val) {
      this.current = val;
      this.getStoreGoodsList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.$emit("refreshDataList", val[0].id, val[0].name);
      this.resetForm();
    },
    getStoreGoodsList() {
      this.searchForm.pageNo = this.current;
      this.searchForm.pageSize = this.size;
      this.$axios
        .post("/admin/merchants/findGarden", this.searchForm)
        .then((res) => {
          this.tableData = res.data;
          this.size = res.data.size;
          this.current = res.data.pages;
          this.total = res.data.total;
        });
    },
    selStoreGood(item) {
      this.$emit("refreshDataList", item.id, item.name);
      this.resetForm();
    },
    init() {
      this.dialogTableVisible = true;
      //this.getStoreGoodsList(relStoreGoodIdList)
      this.getStoreGoodsList();
    },
  },
};
</script>

<style>
.dialogClass .el-dialog__body {
  padding-bottom: 80px;
}
</style>
